/* eslint-disable no-unused-vars */
import SingleCard from 'app/components/SingleCard/SingleCard';
import { setNavHeaderVisibleAction } from 'app/redux/actions/NavHeaderAction';
import { resetWithdrawStateAction } from 'app/redux/actions/WithdrawAction';
import { RootState } from 'app/redux/store';
import ROUTER_PATH from 'app/routes/routerPath';
import ImagePath from 'app/utilities/imagePath';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './AfterWithdrawPage.scss';

const AfterWithdrawPage = function init(): React.ReactElement {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const withdrawState = useSelector((state: RootState) => state.withdrawReducer);
    const { successOnWithdraw, errorOnWithdraw } = withdrawState;

    const successWithdraw = {
        mainText: 'Permintaan Tarik Dana Berhasil',
        subText: 'Anda dapat melihat progres penarikan di halaman Transaction History',
        currencyValue: null,
        mainButtonText: 'Lihat Transaction History',
        secondButtonText: '',
        image: ImagePath.successCheckGif,
        mainTextColor: '#0033A1'
    };

    const failedWithdraw = {
        mainText: 'Permintaan Tarik Dana Gagal',
        subText: withdrawState.message ? withdrawState.message : 'Maaf proses permintaan tarik dana belum dapat diproses',
        currencyValue: null,
        mainButtonText: 'Lihat Dashboard',
        secondButtonText: '',
        image: ImagePath.failedCheckGif,
        mainTextColor: '#D31800'
    };

    function redirect(path: string): void {
        dispatch(resetWithdrawStateAction(true));
        navigate({
            pathname: path
        });
    }

    useEffect(() => {
        if (!successOnWithdraw && !errorOnWithdraw) {
            redirect(ROUTER_PATH.portofolio);
        } else {
            dispatch(setNavHeaderVisibleAction(false));
        }
    }, []);

    useEffect(() => () => {
        dispatch(setNavHeaderVisibleAction(true));
    }, []);

    return (
        <div className="after-withdraw">
            {successOnWithdraw && (
                <SingleCard
                    mainText={successWithdraw.mainText}
                    subText={successWithdraw.subText}
                    currencyValue={successWithdraw.currencyValue}
                    mainButtonText={successWithdraw.mainButtonText}
                    secondButtonText={successWithdraw.secondButtonText}
                    image={successWithdraw.image}
                    mainButtonOnClick={() => redirect(ROUTER_PATH.transactionHistory)}
                    secondButtonOnClick={null}
                    mainTextColor={successWithdraw.mainTextColor}
                />
            )}
            {errorOnWithdraw && (
                <SingleCard
                    mainText={failedWithdraw.mainText}
                    subText={failedWithdraw.subText}
                    currencyValue={failedWithdraw.currencyValue}
                    mainButtonText={failedWithdraw.mainButtonText}
                    secondButtonText={failedWithdraw.secondButtonText}
                    image={failedWithdraw.image}
                    mainButtonOnClick={() => redirect(ROUTER_PATH.portofolio)}
                    secondButtonOnClick={null}
                    mainTextColor={failedWithdraw.mainTextColor}
                />
            )}
        </div>
    );
};

export default AfterWithdrawPage;
